import { useMutation, useQueryClient } from '@tanstack/react-query';
import { restCacheConfig } from '../config/axios';
import { QUERY_KEYS } from '../hooks/hooksUtils';
import { useInfiniteQueryData } from '../hooks/useInfiniteQueryData';
import { RestService } from './RestService';

export const fetchNotifications = ({ pageParam }) => {
  return RestService.get(`/notifications?page=${pageParam}`);
};

export const useNotificationsData = () => {
  return useInfiniteQueryData([QUERY_KEYS.NOTIFICATIONS], fetchNotifications, restCacheConfig);
};

export const useDeleteNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => RestService.delete('/notifications/' + uuid),
    onMutate: async (uuid: string) => {
      await queryClient.cancelQueries({ queryKey: [QUERY_KEYS.NOTIFICATIONS] });
      const oldData = queryClient.getQueryData([QUERY_KEYS.NOTIFICATIONS]);
      if (!!oldData) {
        queryClient.setQueryData([QUERY_KEYS.NOTIFICATIONS], (oldQueryData: any) => {
          return {
            ...oldQueryData,
            pages: oldQueryData.pages.map((pageData: any) => {
              return {
                ...pageData,
                data: pageData.data.filter(item => item.uuid !== uuid)
              };
            })
          };
        });
      }
    }
  });
};

export const handleNewNotification = (queryClient, notification) => {
  const oldData = queryClient.getQueryData([QUERY_KEYS.NOTIFICATIONS]);
  if (!!oldData) {
    queryClient.setQueryData([QUERY_KEYS.NOTIFICATIONS], (oldQueryData: any) => {
      return {
        ...oldQueryData,
        pages: oldQueryData.pages.map((pageData: any, index: number) => {
          const filteredItems = pageData.data.filter(item => item.uuid !== notification.uuid);
          return index === 0 ? [notification, ...filteredItems] : filteredItems;
        })
      };
    });
  }
};
